import * as React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import GlobalStyles from '@mui/material/GlobalStyles';
import { Box } from "@mui/material";
import { Outlet, useLocation } from 'react-router-dom';
import { SidebarSection } from '../components/SidebarSection';
import { HeaderSection } from '../components/HeaderSection';
import ModalContainer from '../components/ModalContainer';
import StartApplication from '../components/StartApplication';
import { useLanguageFromSettings } from '../atoms/userSetting';
import TailSpinLoader from '../components/TailSpinLoader';
import { userSettingSelected } from "../atoms/userSetting"
import { useRecoilValue } from "recoil"
import AsideStack from '../components/AsideStack';
import { bannerOpenState } from '../atoms/banner';
import { useUser } from '../atoms';

function MainPage() {
    const isOpen = useRecoilValue<boolean>(bannerOpenState)
    useLanguageFromSettings()
    const us = useRecoilValue(userSettingSelected)
    const location = useLocation()
    const user = useUser()
    
    return (
        <React.Fragment>
            <GlobalStyles styles={{ ul: { margin: 0, padding: 0, listStyle: 'none' } }} />
            <CssBaseline />
            <HeaderSection />
            <StartApplication />
            <Box sx={{ display: 'flex', alignItems: 'stretch', marginTop: 0.1, height: 'calc(100vh - 62px)' }}>
                <SidebarSection initialOpen={true} />
                <React.Suspense fallback={(<TailSpinLoader color='red'/>)}>
                    <MainContentSection />
                </React.Suspense>
                {!us?.carouselDisabled && isOpen && location.pathname !== "/help" && user.context?.banner === true ?
                    <AsideStack />
                    : null
                }
            </Box>
            <ModalContainer />
        </React.Fragment>
    );
}

export default MainPage

const MainContentSection = () => <Outlet />

